import { Box, Divider, List, ListItemButton, ListItemText, ListItemTextProps, styled, Typography } from '@mui/material'

export const SidebarDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.border.subtle,
  opacity: 0.72,
}))

export const SidebarList = styled(List)(() => ({
  margin: '0px 12px',
  gap: 8,
  display: 'flex',
  flexDirection: 'column',
}))

export const SidebarSubList = styled(List)(() => ({
  padding: 0,
  gap: 12,
  display: 'flex',
  flexDirection: 'column',
}))

export const SidebarBadge = styled(Box)(({ theme }) => ({
  background: theme.palette.bg.neutral.strong,
  color: theme.palette.fg.inverted,
  borderRadius: 10,
  padding: '1px 7px',
  fontSize: 10,
}))

export const SidebarItemWrapper = styled(Box)(() => ({
  margin: '0px 14px',
  gap: 12,
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: 8,
}))

export const SidebarListItemText = ({ sx, ...props }: ListItemTextProps) => (
  <ListItemText
    {...props}
    sx={[{ my: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
    slotProps={{
      primary: { color: 'text.default', variant: 'body-regular' },
    }}
  />
)

export const SidebarListItemSubText = (props: ListItemTextProps) => (
  <ListItemText
    {...props}
    slotProps={{
      primary: { color: 'text.muted', variant: 'body-regular' },
    }}
  />
)

export const SidebarListItemButton = styled(ListItemButton)(({ theme }) => ({
  color: theme.palette.text.default,
  padding: '4px 12px',
  minHeight: 28,
  cursor: 'pointer',
  borderRadius: 8,
  '&.Mui-selected': { backgroundColor: theme.palette.bg.interactive.active },
  ':hover': { backgroundColor: theme.palette.bg.interactive.hover },
}))

export const SidebarListItemSubButton = styled(ListItemButton)(({ theme }) => ({
  color: theme.palette.text.muted,
  p: 0,
  height: 29,
  cursor: 'pointer',
  borderRadius: 4,
  paddingLeft: 12,
  marginLeft: 36,
  '&.Mui-selected': { backgroundColor: theme.palette.bg.interactive.active },
  ':hover': { backgroundColor: theme.palette.bg.interactive.hover },
}))

export const SidebarSectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Typography
    variant="body-regular"
    sx={{
      px: 6,
      mb: 1,
      color: 'text.muted',
    }}
  >
    {children}
  </Typography>
)
